import {combineReducers} from 'redux';
import loadReduser from './load';
import modalReduser from './modal';
import localeReduser from "./locale";
import lampReduser from "./lamp";
import appReduser from "./test_app";

let redusers = {
    loadState: loadReduser,
    modalState: modalReduser,
    localeState: localeReduser,
    lampState: lampReduser,
    appState: appReduser,
}

const allRedusers = combineReducers(redusers);

export default allRedusers;